import React from "react";
import { formatMessage } from "lib/globalize-util";
import { PromptDialog } from "@nuorder/components";

interface IOwnProps {
    open: boolean;
    onConfirm: (value: string, callback?: () => void) => void;
    onClose: () => void;
    initialName?: string;
    isLoading?: boolean;
    disableConfirm?: boolean;
}

export const CopyFolderDialog: React.FunctionComponent<IOwnProps> = ({
    open,
    onConfirm,
    onClose,
    initialName,
    isLoading,
}) => {
    return (
        <PromptDialog
            title={formatMessage("Copy Folder")}
            confirmLabel={formatMessage("New Name")}
            open={open}
            onConfirm={onConfirm}
            onClose={onClose}
            initialValue={initialName}
            isLoading={isLoading}
            errorMessage={formatMessage("You can't leave this blank.")}
            customTextForSave={formatMessage("Save")}
            customTextForCancel={formatMessage("Cancel")}
            closeButtonAriaLabel={formatMessage("Close")}
            blankErrorMessage={formatMessage("You can't leave this blank.")}
        />
    );
};
